import Locate from "@arcgis/core/widgets/Locate";
export function initLocate(mapView, position) {
    let locate = new Locate({
        view: mapView
    });
    //   locate.locate().then(value =>{
    //   })
    console.log(locate);
    mapView.ui.add(locate, position);
}
